/* RG kokoelmasuodatin – fasetit Dawnin tuotekorteista, ei hintoja. */
(function () {
  'use strict';
  var SIZE_RE = /(\d+(?:[.,]\d+)?)\s?cm\b/i;
  var BUCKETS = [20, 40, 70];
  function fmt(t, n) { return (t || '').replace('{n}', n); }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function init(root) {
    if (root.__rgGf) return;
    var grid = document.getElementById('product-grid');
    if (!grid || grid.classList.contains('collection--empty')) return;
    root.__rgGf = true;
    var d = root.dataset;
    var total = parseInt(d.total, 10) || 0;
    var vocab = (d.colors || '').split(',').map(function (x) { return x.trim().toLowerCase(); }).filter(Boolean).sort(function (a, b) { return b.length - a.length; });
    var vocabRe = vocab.length ? new RegExp('(?<![\\p{L}])(' + vocab.map(function (v) { return v.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }).join('|') + ')(?![\\p{L}])', 'iu') : null;
    var groupsEl = root.querySelector('[data-rg-gf-groups]');
    var countEl = root.querySelector('[data-rg-gf-count]');
    var clearBtn = root.querySelector('[data-rg-gf-clear]');
    var active = {}; // group -> Set(values)
    var loadedAll = false, loading = false;

    function cards() {
      return Array.prototype.slice.call(grid.querySelectorAll('.card-wrapper[data-rg-title]'));
    }
    function item(card) { return card.closest('.grid__item') || card; }
    function facetsOf(card) {
      if (card.__rgF) return card.__rgF;
      var t = card.dataset.rgTitle || '', low = t.toLowerCase();
      var f = {};
      var m = t.match(SIZE_RE); if (m) f.size = parseFloat(m[1].replace(',', '.'));
      if (vocabRe) { var c = low.match(vocabRe); if (c) f.color = c[1].toLowerCase(); }
      if (card.dataset.rgType) f.type = card.dataset.rgType;
      if (card.dataset.rgVendor) f.vendor = card.dataset.rgVendor;
      f.set = /\bsetti\b|\bsarja\b|\bpakkaus\b|\d+\s?kpl|\d+-pack\b|\bset of\b|\bkomplekt\b|\d+\s?tk\b|\d+\s?st\b/i.test(low) ? 'set' : 'single';
      card.__rgF = f; return f;
    }
    function cap(s) { return s.charAt(0).toUpperCase() + s.slice(1); }
    function sizeLabel(v) { return (Number.isInteger(v) ? v : v.toFixed(1).replace('.', ',')) + ' cm'; }
    function bucketOf(v) { for (var i = 0; i < BUCKETS.length; i++) if (v < BUCKETS[i]) return i; return BUCKETS.length; }
    function bucketLabel(i) { if (i === 0) return fmt(d.lUnder, BUCKETS[0]); if (i === BUCKETS.length) return fmt(d.lOver, BUCKETS[BUCKETS.length - 1]); return BUCKETS[i - 1] + '–' + BUCKETS[i] + ' cm'; }

    function build() {
      var cs = cards(); if (!cs.length) return;
      var groups = [];
      function collect(key, on, labelFn, sortFn) {
        if (on !== 'true') return;
        var vals = {}; cs.forEach(function (c) { var v = facetsOf(c)[key]; if (v !== undefined && v !== '') vals[v] = (vals[v] || 0) + 1; });
        var keys = Object.keys(vals); if (keys.length < 2) return;
        groups.push({ key: key, values: keys.sort(sortFn).map(function (v) { return { v: v, n: vals[v], label: labelFn(v) }; }) });
      }
      // size: exact chips or buckets
      if (d.size === 'true') {
        var sizes = {}; cs.forEach(function (c) { var v = facetsOf(c).size; if (v !== undefined) sizes[v] = (sizes[v] || 0) + 1; });
        var sk = Object.keys(sizes).map(Number).sort(function (a, b) { return a - b; });
        if (sk.length >= 2) {
          if (sk.length <= 12) groups.push({ key: 'size', values: sk.map(function (v) { return { v: String(v), n: sizes[v], label: sizeLabel(v) }; }) });
          else {
            var b = {}; sk.forEach(function (v) { var i = bucketOf(v); b[i] = (b[i] || 0) + sizes[v]; });
            groups.push({ key: 'size', bucket: true, values: Object.keys(b).map(Number).sort(function (a, c) { return a - c; }).map(function (i) { return { v: 'b' + i, n: b[i], label: bucketLabel(i) }; }) });
          }
        }
      }
      collect('color', d.color, cap, function (a, b) { return a.localeCompare(b, 'fi'); });
      collect('type', d.type, function (v) { return v; }, function (a, b) { return a.localeCompare(b, 'fi'); });
      collect('vendor', d.vendor, function (v) { return v; }, function (a, b) { return a.localeCompare(b, 'fi'); });
      collect('set', d.set, function (v) { return v === 'set' ? d.lSetval : d.lSingle; }, function (a, b) { return a === 'single' ? -1 : 1; });
      var labels = { size: d.lSize, color: d.lColor, type: d.lType, vendor: d.lVendor, set: d.lSet };
      var html = groups.map(function (g) {
        return '<div class="rg-gf__group" data-group="' + g.key + '"><span class="rg-gf__label">' + esc(labels[g.key] || g.key) + '</span><div class="rg-gf__chips">' +
          g.values.map(function (o) { var on = active[g.key] && active[g.key].has(o.v); return '<button type="button" class="rg-gf__chip' + (on ? ' is-active' : '') + '" data-group="' + g.key + '" data-value="' + esc(o.v) + '" aria-pressed="' + (on ? 'true' : 'false') + '">' + esc(o.label) + '<span class="rg-gf__n">' + o.n + '</span></button>'; }).join('') + '</div></div>';
      }).join('');
      if (!loadedAll && total > cs.length) html += '<div class="rg-gf__more"><button type="button" class="rg-gf__all" data-rg-gf-all>' + esc(fmt(d.lAll, total)) + '</button></div>';
      groupsEl.innerHTML = html;
      root.hidden = groups.length === 0 && (loadedAll || total <= cs.length);
      apply();
    }
    function matches(f) {
      for (var g in active) {
        if (!active[g].size) continue;
        var v = f[g];
        if (g === 'size') {
          if (v === undefined) return false;
          var want = active[g]; var ok = false;
          want.forEach(function (w) { if (w.charAt(0) === 'b') { if (bucketOf(v) === parseInt(w.slice(1), 10)) ok = true; } else if (parseFloat(w) === v) ok = true; });
          if (!ok) return false;
        } else if (!active[g].has(String(v))) return false;
      }
      return true;
    }
    function anyActive() { for (var g in active) if (active[g].size) return true; return false; }
    function apply() {
      var cs = cards(), shown = 0;
      cs.forEach(function (c) { var ok = matches(facetsOf(c)); item(c).classList.toggle('rg-gf-hidden', !ok); if (ok) shown++; });
      var act = anyActive();
      countEl.textContent = fmt(d.lCount, act || loadedAll ? shown : total);
      clearBtn.hidden = !act;
      var pag = document.querySelector('.pagination-wrapper'); if (pag) pag.classList.toggle('rg-gf-hidden', loadedAll);
      root.classList.toggle('is-filtering', act);
    }
    function loadAll(cb) {
      if (loadedAll || loading) { if (cb && loadedAll) cb(); return; }
      var cs = cards(); var perPage = cs.length; if (!perPage || total <= perPage) { loadedAll = true; if (cb) cb(); return; }
      loading = true; root.classList.add('is-loading');
      var allBtn = root.querySelector('[data-rg-gf-all]'); if (allBtn) allBtn.textContent = d.lLoading;
      var url = new URL(location.href); var cur = parseInt(url.searchParams.get('page') || '1', 10);
      var pages = Math.ceil(total / perPage), sectionId = grid.getAttribute('data-id');
      var jobs = [];
      for (var p = 1; p <= pages; p++) if (p !== cur) (function (p) {
        var u = new URL(location.href); u.searchParams.set('page', p); u.searchParams.set('sections', sectionId);
        jobs.push(fetch(u.toString()).then(function (r) { return r.json(); }).then(function (j) { return { p: p, html: j[sectionId] || '' }; }).catch(function () { return { p: p, html: '' }; }));
      })(p);
      Promise.all(jobs).then(function (res) {
        res.sort(function (a, b) { return a.p - b.p; });
        var frag = document.createDocumentFragment(), before = [], after = [];
        res.forEach(function (r) { var doc = new DOMParser().parseFromString(r.html, 'text/html'); var items = doc.querySelectorAll('#product-grid .grid__item'); items.forEach(function (li) { li.classList.remove('scroll-trigger', 'animate--slide-in'); (r.p < cur ? before : after).push(li); }); });
        before.forEach(function (li) { frag.appendChild(li); }); grid.insertBefore(frag, grid.firstChild);
        after.forEach(function (li) { grid.appendChild(li); });
        loadedAll = true; loading = false; root.classList.remove('is-loading');
        build(); if (cb) cb();
        if (window.Shopify && window.Shopify.designMode) return;
      });
    }
    root.addEventListener('click', function (e) {
      var chip = e.target.closest('.rg-gf__chip');
      if (chip) {
        var g = chip.dataset.group, v = chip.dataset.value;
        active[g] = active[g] || new Set();
        if (active[g].has(v)) active[g].delete(v); else active[g].add(v);
        var go = function () { build(); };
        if (!loadedAll && total > cards().length) loadAll(go); else go();
        return;
      }
      if (e.target.closest('[data-rg-gf-clear]')) { active = {}; build(); return; }
      if (e.target.closest('[data-rg-gf-all]')) { loadAll(); }
    });
    // Dawn korvaa ruudukon lajittelun yhteydessä → rakenna uudelleen
    var container = document.getElementById('ProductGridContainer');
    if (container) {
      var t; new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { var g2 = document.getElementById('product-grid'); if (g2 && g2 !== grid) { grid = g2; loadedAll = false; build(); } }, 60); }).observe(container, { childList: true, subtree: true });
    }
    // Esivalinta URL-parametreista: rg_koko=84 · rg_vari=jokikivi · rg_tyyppi=Mondo · rg_brandi=Ecopots · rg_pakkaus=set (hotspot- ja valitsinlinkit)
    var sp = new URL(location.href).searchParams, pmap = { rg_koko: 'size', rg_vari: 'color', rg_tyyppi: 'type', rg_brandi: 'vendor', rg_pakkaus: 'set' }, pre = false;
    Object.keys(pmap).forEach(function (k) { var v = sp.get(k); if (v) { active[pmap[k]] = new Set(v.split(',').map(function (x) { x = x.trim(); return pmap[k] === 'color' ? x.toLowerCase() : x; })); pre = true; } });
    if (pre && !loadedAll && total > cards().length) { loadAll(); return; }
    build();
  }
  function boot() { document.querySelectorAll('[data-rg-gf]').forEach(init); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
